import React from 'react';
import { ILandingPageDesignResponse } from '../../../types';
import { Flex } from 'lib/components/styles/layout';
import { LP_DESIGN_SOCIAL_MEDIA } from '../../../constants';
import { SocialIcon } from '../../../helpers/socialIcons';
import { FooterContainer } from './styles';
import { getFooterLogo, SOCIAL_ICONS } from '../constants';

interface IFooterProps {
  landingPageDesign: Partial<ILandingPageDesignResponse>;
}

export const Footer = ({ landingPageDesign }: IFooterProps) => {
  const {
    footerBackgroundColor,
    socialMediaIconType,
    footerLogo,
    showSocialMediaIcons,
    showFooterShadow,
  } = landingPageDesign;

  const logoSize = { width: 78, height: 8 };
  const LOGO_TYPE = getFooterLogo(logoSize);

  return (
    <FooterContainer
      footerBackgroundColor={footerBackgroundColor}
      showFooterShadow={showFooterShadow}
    >
      <Flex gap='6px' alignItems='center' justifyContent='center'>
        {!!showSocialMediaIcons && (
          <Flex
            flexDirection='row'
            gap='4px'
            justifyContent='center'
            flexWrap='wrap'
            style={{ boxSizing: 'border-box' }}
          >
            {SOCIAL_ICONS.map((icon, idx) => (
              <SocialIcon
                key={idx}
                size={5}
                svgSize={10}
                icon={icon}
                design={
                  socialMediaIconType ?? LP_DESIGN_SOCIAL_MEDIA.WHITE_SQUARE
                }
              />
            ))}
          </Flex>
        )}
        {footerLogo && LOGO_TYPE[footerLogo]}
      </Flex>
    </FooterContainer>
  );
};
